export default "__VITE_ASSET__CGc5WFt6__"